import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { FormGroup, Select } from 'components/common/form';

import type { GetCategoriesRes } from 'shared-types/responses';

interface Props {
  disabled?: boolean;
}

const CalendarEventCategories = ({ disabled = false }: Props) => {
  const { data } = useApiData<GetCategoriesRes>({
    url: '/admin/categories-calendar-events'
  });

  const { messages } = useReduxState();

  const categories = [
    {
      label: messages.eventCalendarCategoryExternal,
      value: messages.eventCalendarCategoryExternal
    },
    {
      label: messages.eventCalendarCategoryInternal,
      value: messages.eventCalendarCategoryInternal
    },
    {
      label: messages.eventCalendarCategoryLive,
      value: messages.eventCalendarCategoryLive
    },
    {
      label: messages.eventCalendarCategoryWebinar,
      value: messages.eventCalendarCategoryWebinar
    },
    ...(data?.categories
      ?.filter(
        ({ title }) =>
          ![
            messages.eventCalendarCategoryExternal,
            messages.eventCalendarCategoryInternal,
            messages.eventCalendarCategoryLive,
            messages.eventCalendarCategoryWebinar
          ].includes(title)
      )
      .map(({ title }) => ({ label: title, value: title })) || [])
  ];

  return (
    <FormGroup label={messages.commonCategories}>
      <Select
        creatable={true}
        disabled={disabled}
        field="categories"
        id="categories"
        isClearable={true}
        isMulti={true}
        isSearchable={true}
        noOptionsMessage={messages.settingsNoCategoriesFound}
        options={categories}
        placeholder={messages.settingsAddCategory}
      />
    </FormGroup>
  );
};

export default CalendarEventCategories;
